export default "__VITE_ASSET__DSH$LfFm__"